/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CoachSuggestionStatus from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestionStatus';
import CoachSuggestionTitle from 'bundles/ai-coach-platform/components/patterns/suggestions/CoachSuggestionTitle';

const styles = {
  suggestionHeader: css`
    display: flex;
    flex: 1;
    justify-content: space-between;
  `,
};

type Props = React.PropsWithChildren<{
  header?: React.ReactNode;
}>;

export type CoachSuggestionHeaderComponent = React.ReactElement<Props>;

const CoachSuggestionHeader = ({ header, children }: Props) => {
  if (header) {
    return header;
  }

  return (
    <div css={styles.suggestionHeader}>
      <CoachSuggestionTitle>{children}</CoachSuggestionTitle>
      <CoachSuggestionStatus />
    </div>
  );
};

export default CoachSuggestionHeader;
